<header class="topbar">
  <div class="brand-lock">
    <a class="brand-lock__mark" [routerLink]="activeLink" aria-label="3DWay">3DWay</a>
    <nav class="brand-lock__products" aria-label="3DWay products">
      <ng-container *ngFor="let product of products; let last = last">
        <a
          class="brand-lock__product"
          [class.is-active]="product.id === active"
          [routerLink]="product.link"
          [attr.aria-current]="product.id === active ? 'page' : null">{{ product.label }}</a>
        <span *ngIf="!last" class="brand-lock__divider" aria-hidden="true"></span>
      </ng-container>
    </nav>
  </div>
  <button class="topbar-account" type="button" (click)="onAccountClick()">Account</button>
</header>
